import Vue from 'vue'

import moment from 'moment'
moment.locale('ar-ly')

Vue.filter('formatBytes', function(bytes){
  if(bytes == 0) return '0 Bytes';
  let k = 1024,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
})

Vue.filter('toChar', function (value) {
  return String.fromCharCode(value)
})

Vue.filter('capitalize', function (value) {
	if (!value) return ''
	value = value.toString()
	let arr = value.split(" ")
	let capitalized_array = []
	arr.forEach((word) => {
		let capitalized = word.charAt(0).toUpperCase() + word.slice(1)
		capitalized_array.push(capitalized)
	})
	return capitalized_array.join(" ");
})

Vue.filter('truncate', function(value, limit) {
	return value.substring(0, limit)
})

Vue.filter('tailing', function(value, tail) {
	return value + tail;
})

Vue.filter('ago', function(value){
    let today = moment();
    let fromAgo = moment(value);
    if(today.isSame(fromAgo, 'day')){
      return fromAgo.fromNow()
    } else if (today.isSame(fromAgo, 'year')){
      return fromAgo.format('Do MMMM . h:mm A')
    } else {
      return fromAgo.format('Do MMMM, YYYY')
    }
})

Vue.filter('fromNow', function(value){
    return moment(value).fromNow()
})

Vue.filter('date_time', function(value, is24Hr = true){
  let time_base = is24Hr ? 'HH:mm' : 'hh:mm A'
  return moment(value).format(time_base + ' • Y/M/D' )
})

Vue.filter('reg_date', function(value) {
    return moment(value).format('HH:mm Y-M-D' )
})

Vue.filter('time', function(value, is24HrFormat = false) {
	// if(value) {
	// 	const date = new Date(Date.parse(value));
	// 	let hours = date.getHours();
	// 	const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
	// 	if(!is24HrFormat) {
	// 		const time = hours >= 12 ? 'م' : 'ص';
	// 		hours = hours % 12 || 12;
	// 		return hours + ':' + min + ' ' + time
	// 	}
	// 	return hours + ':' + min
	// }
    return is24HrFormat ? moment(value).format('HH:mm') : moment(value).format('hh:mm a')
})

Vue.filter('date', function(value, fullDate = false) {
  // const locale = "ar-ly";
  // const date_obj = new Date(Date.parse(value));
  //   console.log('date filter:', value, date_obj) // object_obj Invalid date
  // const monthName = date_obj.toLocaleString(locale, {
  //   month: 'short'
  // });
  //
  // if(fullDate) return date_obj.getDate() + ' ' + monthName + ', ' + date_obj.getFullYear();
  // else return date_obj.getDate() + ' '  + monthName;
    return fullDate ? moment(value).format('DD MMM YYYY') : moment(value).format('DD MMM')
})

Vue.filter('month', function(val, showYear = true) {
  if(!showYear){
    return moment(val).format('MMM')
  } else {
    return moment(val).format('MMM Y')
  }
})

Vue.filter('csv', function(value) {
	return value.join(', ')
})

Vue.filter('filter_tags', function(value) {
	return value.replace(/<\/?[^>]+(>|$)/g, "")
})

Vue.filter('k_formatter', function(num) {
	return num > 999 ? (num/1000).toFixed(1) + 'k' : num
})
